import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiTechnicalAssistancePageData = () => {
    const { strapiTechnicalAssistancePage } = useStaticQuery(graphql`
      query {
        strapiTechnicalAssistancePage {
            title
            slug
            description
            keywords
            image {
              localFile {
                url
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
            hero_image {
              headline
              description {
                data {
                  childMarkdownRemark {
                    html
                  }
                }
              }
              background_image {
                localFile {
                  url
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
            resources {
              slug
              title
              card_title
              category {
                name
              }
              author
              resource_date(formatString: "YYYY")
              body {
                data {
                  childMarkdownRemark {
                    excerpt(format: HTML, pruneLength: 136)
                    rawMarkdownBody
                  }
                }
              }
              thumbnail {
                alternativeText
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              pdf {
                name
                localFile {
                  prettySize
                }
              }
            }  
            text {
              data {
                childMarkdownRemark {
                  html
                }
              }
            }
            videos_and_webinars {
                slug
                title
                card_title
                category {
                  name
                }
                author
                date(formatString: "MMMM DD, YYYY")
                body {
                  data {
                    childMarkdownRemark {
                      rawMarkdownBody
                      excerpt(format: HTML, pruneLength: 136)
                    }
                  }
                }
                thumbnail {
                  alternativeText
                  localFile {
                    childrenImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                video_url
              }
          }
        }
    `)

    return { strapiTechnicalAssistancePage }
  }
